import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconStatsBg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={20}
    fill="none"
    viewBox="0 0 32 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-stats-bg_svg__a)"
      d="M0 9c0-1.063.875-2 2-2h12v6H2c-1.125 0-2-.875-2-2V9Zm30-2c1.063 0 2 .938 2 2v2c0 1.125-.938 2-2 2h-4v4a3 3 0 0 1-3 3h-4c-1.688 0-3-1.313-3-3V3a3 3 0 0 1 3-3h4c1.625 0 3 1.375 3 3v4h4Zm-8 9V4h-2v12h2Z"
    />
    <defs>
      <linearGradient
        id="icon-stats-bg_svg__a"
        x1={32}
        x2={0}
        y1={-6}
        y2={26}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#8FAAED" />
        <stop offset={0.18} stopColor="#718BE9" />
        <stop offset={0.73} stopColor="#4F6DD9" />
        <stop offset={1} stopColor="#4562CA" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconStatsBg;
